import { useCallback, useEffect, useState } from "react";
import { getClassroomHandoverClasses } from "../services/APIClient";

export default function useHandoverClassrooms({ schoolId, selection }) {
  const [classes, setClasses] = useState([]);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState(null);
  const academicYear = selection?.academicYear;
  const progressionKey = selection?.progressionKey;

  const load = useCallback(async () => {
    if (!schoolId || !academicYear || !progressionKey) {
      setClasses([]);
      setStatus("idle");
      return [];
    }
    setStatus("loading");
    setError(null);
    try {
      const response = await getClassroomHandoverClasses(schoolId, { academicYear, progressionKey });
      const nextClasses = response?.classes || [];
      setClasses(nextClasses);
      setStatus("ready");
      return nextClasses;
    } catch (nextError) {
      setClasses([]);
      setError(nextError);
      setStatus(nextError?.response?.status === 403 ? "forbidden" : "error");
      throw nextError;
    }
  }, [academicYear, progressionKey, schoolId]);

  useEffect(() => {
    load().catch(() => {});
  }, [load]);

  return { classes, status, error, load };
}
